<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{$t('Structures')}}</h1>
          <h2 class="page-subtitle">{{ totalCount }} {{ totalCount === 1 ? $t('structure') + $t('saved.f') : $t('structures') + $t('saved.f.s')}}</h2>
        </div>
        <b-button class="ph-btn" variant="primary" @click="clickOnCreateBtn" v-if="allowCreate">
          {{$t('Add2')}} {{$t('a.e')}} {{$t('structure')}} <i class="ph-custom ph-user-plus-fill ml-1"/>
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableStructure"
          identifier="B122TableStructure"
          get-b122-table-results-url="/structure/getB122TableResults"
          :fields="tableFields"
          :editItem=allowEdit
          :deleteItem=allowDelete
          :empty-title="$t('structure.emptyTitle').toString()"
          :empty-text="$t('structure.emptyText').toString()"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn">
          <template #cell(actions)="row">
            <div class="actions-container text-right" v-if="!row.item.isDefaultStructure">
              <button class="action-btn edit mr-1" @click="clickOnEditBtn(row)" v-if="allowEdit">
                <i class="ph-custom ph-pencil-simple-line-fill"/>
              </button>
              <button class="action-btn delete" @click="clickOnDeleteBtn(row)" v-if="allowDelete">
                <i class="ph-custom ph-trash-fill"/>
              </button>
            </div>
          </template>
        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="true"
      :selectedItem="selectedItem"
      controllerName="structure"
      itemSingularName="structure"
      itemSingularNameUpp="Structure"
      @didDeleteItem="didDeleteItem()">
    </Item-delete-modal>

  </div>
</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'
export default {

  name: 'StructureIndex',

  components: {
    B122Table,
    ItemDeleteModal
  },

  data () {
    return {

      totalCount: 0,
      allowCreate: this.$store.getters.isAdmin || this.$store.getters.isSuperAdmin,
      allowDelete: this.$store.getters.isAdmin || this.$store.getters.isSuperAdmin,
      allowEdit: this.$store.getters.isAdmin || this.$store.getters.isSuperAdmin,
      selectedItem: null
    }
  },

  computed: {

    tableFields () {
      return [
        {
          label: '',
          key: 'show',
          sortable: false,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('structure.name'),
          key: 'structureName',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('structure.Contact'),
          key: 'contactName',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('user.Username'),
          key: 'user.username',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('user.PhoneNumber'),
          key: 'user.phoneNumber',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('Technicians'),
          key: 'nbTechnicians',
          sortable: false,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('Farmers'),
          key: 'nbFarmers',
          sortable: false,
          tdClass: 'max-width-cell'
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'max-width-cell'
        }
      ]
    }

  },

  methods: {

    setTotalCount (totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn () {
      this.$router.push({
        name: 'StructureCreate'
      })
    },

    clickOnShowBtn (row) {
      this.$router.push({
        name: 'StructureShow',
        params: {
          structureId: row.item.id
        }
      })
    },

    clickOnEditBtn (row) {
      this.$router.push({
        name: 'StructureEdit',
        params: {
          structureId: row.item.id
        }
      })
    },

    clickOnDeleteBtn (row) {
      this.selectedItem = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteItem () {
      this.selectedItem = null
      this.$refs.B122TableStructure.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/structure/StructureIndex.vue